import React from 'react';
import { Ic, ICONS } from '../../data/icons';
import { NAV_ITEMS } from '../../data/mockData';

export default function Sidebar({ C, collapsed, onToggle, active, onNav, mobile, onClose, currentUser }) {
  const W   = collapsed ? 64 : 232;
  const isAdmin = currentUser?.is_system_owner || currentUser?.role === 'Süper Admin';

  const NavBtn = ({ icon, label, badge, active: isActive, onClick, danger }) => (
    <button onClick={onClick} title={collapsed ? label : undefined} style={{
      width:'100%', display:'flex', alignItems:'center', gap:10,
      padding: collapsed ? '10px 0' : '10px 14px',
      justifyContent: collapsed ? 'center' : 'flex-start',
      borderRadius:10, border:`1px solid transparent`, cursor:'pointer',
      background: isActive ? C.accentBg : 'transparent',
      color: isActive ? C.accent : danger ? '#ef4444' : C.textSub,
      transition:'all 0.15s', position:'relative', textAlign:'left',
    }}
      onMouseEnter={e => { if (!isActive) { e.currentTarget.style.background = C.surface2; e.currentTarget.style.borderColor = C.border; }}}
      onMouseLeave={e => { if (!isActive) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = 'transparent'; }}}
    >
      {isActive && !collapsed && <span style={{ position:'absolute', left:0, top:'50%', transform:'translateY(-50%)', width:3, height:18, background:C.accent, borderRadius:'0 3px 3px 0' }} />}
      <Ic d={ICONS[icon]} size={18} s={isActive ? C.accent : danger ? '#ef4444' : C.textSub} />
      {!collapsed && (
        <span style={{ fontSize:13.5, fontWeight: isActive ? 700 : 400, flex:1, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{label}</span>
      )}
      {!collapsed && badge > 0 && (
        <span style={{ fontSize:10, fontWeight:700, background:'#ef4444', color:'#fff', padding:'1px 6px', borderRadius:99, marginLeft:'auto' }}>{badge}</span>
      )}
      {collapsed && badge > 0 && (
        <span style={{ position:'absolute', top:6, right:6, width:8, height:8, background:'#ef4444', borderRadius:'50%' }} />
      )}
    </button>
  );

  return (
    <div style={{ width:W, height:'100vh', background:C.sidebar, borderRight:`1px solid ${C.border}`, display:'flex', flexDirection:'column', transition:'width 0.22s ease', overflow:'hidden', flexShrink:0, position:'relative', zIndex:20 }}>
      {/* Logo */}
      <div style={{ height:60, display:'flex', alignItems:'center', padding: collapsed ? '0 12px' : '0 16px', gap:10, borderBottom:`1px solid ${C.border}`, flexShrink:0, overflow:'hidden' }}>
        <div style={{ width:32, height:32, borderRadius:9, background:'linear-gradient(135deg,#3b82f6,#8b5cf6)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, boxShadow:'0 2px 10px rgba(59,130,246,0.4)' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
        </div>
        {!collapsed && <div style={{ fontWeight:900, fontSize:15, color:C.text, letterSpacing:'-0.5px', whiteSpace:'nowrap' }}>CorpMDM</div>}
        {!collapsed && (
          <button onClick={onToggle} style={{ marginLeft:'auto', background:'none', border:`1px solid ${C.border}`, borderRadius:7, cursor:'pointer', color:C.textFaint, width:26, height:26, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            <Ic d={ICONS.chevL} size={12} />
          </button>
        )}
      </div>

      {/* Nav items */}
      <div style={{ flex:1, overflowY:'auto', overflowX:'hidden', padding:'10px 8px' }}>
        {!collapsed && <div style={{ fontSize:10, fontWeight:700, color:C.textFaint, letterSpacing:'1px', padding:'6px 8px 4px', marginTop:2 }}>MENÜ</div>}

        {NAV_ITEMS.map(item => (
          <NavBtn key={item.key} icon={item.icon} label={item.label} badge={item.badge} active={active === item.key} onClick={() => onNav(item.key)} />
        ))}

        {/* Admin Bölümü — sadece sistem sahibi/süper admin görür */}
        {isAdmin && (
          <>
            {!collapsed && (
              <div style={{ fontSize:10, fontWeight:700, color:'#f59e0b', letterSpacing:'1px', padding:'14px 8px 4px', display:'flex', alignItems:'center', gap:6 }}>
                <Ic d={ICONS.key} size={11} s='#f59e0b' /> YÖNETİCİ
              </div>
            )}
            {collapsed && <div style={{ height:1, background:C.border, margin:'10px 4px' }} />}
            <NavBtn
              icon='shield'
              label='Admin Paneli'
              active={active === 'admin'}
              onClick={() => onNav('admin')}
            />
            <NavBtn
              icon='qrcode'
              label='MDM Kaydı'
              active={active === 'enrollment'}
              onClick={() => onNav('enrollment')}
            />
            <NavBtn
              icon='package'
              label='Uygulamalar (Yön.)'
              active={active === 'apps-management'}
              onClick={() => onNav('apps-management')}
            />
            {!collapsed && (
              <div style={{ margin:'6px 6px 0', padding:'8px 10px', background:'rgba(245,158,11,0.06)', borderRadius:8, border:'1px solid rgba(245,158,11,0.15)' }}>
                <div style={{ fontSize:10.5, color:'#fde68a', lineHeight:1.5 }}>
                  👁 Bu bölüm yalnızca sistem sahibine görünür
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Collapse toggle (collapsed mod) */}
      {collapsed && (
        <button onClick={onToggle} style={{ margin:'8px auto', display:'flex', alignItems:'center', justifyContent:'center', width:36, height:36, borderRadius:9, border:`1px solid ${C.border}`, background:'transparent', cursor:'pointer', color:C.textFaint }}>
          <Ic d={ICONS.chevR} size={13} />
        </button>
      )}

      {/* Mobile close */}
      {mobile && (
        <button onClick={onClose} style={{ margin:'0 8px 12px', display:'flex', alignItems:'center', justifyContent:'center', gap:8, height:38, borderRadius:9, border:`1px solid ${C.border}`, background:'transparent', cursor:'pointer', color:C.textSub, fontSize:13 }}>
          <Ic d={ICONS.x} size={14} /> Kapat
        </button>
      )}
    </div>
  );
}
